module.exports = __webpack_public_path__ + "img/d5e2814.jpg";